// Each item: { key, path, top, bottomLeft, bottomRight, feature?, brands? }
//
// `feature` (optional) — names the backend feature flag (see
// backend/shared/features.js). The entry is hidden when the flag is explicitly
// `false` in state.features.flags. Missing flag or `true` → shown.
//
// `brands` (optional) — list of brand IDs the entry is allowed to appear on.
// When omitted, the entry is shown on all brands. The brand is taken from
// `config.brand` (set per-brand in config.{jobalto,profitroll}.json).
const MENU_ITEMS = [
  { key: 'Evaluation',   path: 'assessment',     top: true,  bottomLeft: true,  bottomRight: false, feature: 'assessments' },
  { key: 'Consultants',  path: 'counselors',     top: true,  bottomLeft: true,  bottomRight: false, feature: 'consultants' },
  { key: 'Skills',       path: 'skills',         top: true,  bottomLeft: true,  bottomRight: false, feature: 'skills' },
  { key: 'Professions',  path: 'professions',    top: true,  bottomLeft: true,  bottomRight: false, feature: 'professions' },
  // Education / Vacancies / Articles are profitroll-only content modules.
  // The features are still enabled on jobalto's backend (so direct URLs work
  // and existing inbound links don't 404), but we don't surface them in the
  // jobalto chrome — the jobalto landing focuses on the /pro assessment flow.
  { key: 'Education',    path: 'education',      top: false, bottomLeft: true,  bottomRight: false, feature: 'education',  brands: ['profitroll'] },
  { key: 'Vacancies',    path: 'vacancies',      top: false, bottomLeft: true,  bottomRight: false, feature: 'vacancies',  brands: ['profitroll'] },
  { key: 'Pro',          path: 'pro',            top: false, bottomLeft: false, bottomRight: true,  feature: 'assessments' },
  { key: 'Articles',     path: 'articles',       top: false, bottomLeft: false, bottomRight: true,  feature: 'articles',   brands: ['profitroll'] },
  // Mentors page lists consultant profiles; tied to the same backend collection.
  { key: 'Mentors',      path: 'mentors',        top: false, bottomLeft: false, bottomRight: false, feature: 'consultants' },
  { key: 'About',        path: 'about',          top: false, bottomLeft: false, bottomRight: true  },
  { key: 'SignUp',       path: 'sign-up',        top: false, bottomLeft: false, bottomRight: true,  hideIfAuth: true },
  { key: 'Profile',      path: 'dashboard',      top: false, bottomLeft: false, bottomRight: true  },
  { key: 'Policy',       path: 'policy',         top: false, bottomLeft: false, bottomRight: true  }
];

const SOCIAL_MEDIA = {
  instagram: 'https://instagram.com/prftroll',
  tiktok: 'https://tiktok.com/@prftroll',
  youtube: 'https://www.youtube.com/@prftroll',
  telegram_channel: 'https://t.me/prftroll',
  telegram_bot: 'https://t.me/ProfitrollUABot',
  linkedin: 'https://www.linkedin.com/company/jobatlas-llc'
};

export { MENU_ITEMS, SOCIAL_MEDIA };
